/* eslint-disable no-unused-vars */
import { Championship } from './championship';
import { Stage } from './stage';

/**
 * Tipos de campeonato da temporada
 */
export enum SeasonType {
  LEAGUE = 'LEAGUE',
  KNOCKOUT = 'KNOCKOUT',
  HYBRID = 'HYBRID',
}

/**
 * Temporada
 */
export type Season = {
  uuid: string;
  championship_uuid: string;
  current_stage_uuid?: string;
  stages?: Stage[];
  type: SeasonType;
  year: number;
  is_filtered: boolean;
  is_active: boolean;
  /**
   * Visibilidade das colunas da tabela de classificação no app do torcedor.
   * `null`/chave ausente = coluna visível (default tudo visível).
   */
  standings_columns?: Record<string, boolean> | null;
  created_at: string;
  updated_at: string;
  championship?: Championship;
};
